<template>
  <div style="margin: 0 50px">
    <el-steps :active="active" finish-status="success">
      <el-step :title="showTitle0" :description="weatherInfo"></el-step>
      <el-step :title="showTitle1" :description="selectDevice"></el-step>
      <el-step :title="showTitle2" :description="endMsg"></el-step>
    </el-steps>
    <div v-if="active === 0">
      <div style="height: 60px;margin-top: 40px;text-align: center;font-size: 20px">
        <span>新设备是否已经插卡开机，并且通讯测试成功？</span>
      </div>
      <div>
        <el-row>
          <el-col :span="12">
            <div class="cancel-btn" @click="isNo()">
              <span>否</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="send-btn" @click="isYes()">
              <span>是</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="height: 30px;"></div>
    </div>
    <div v-if="active === 1">
      <div style="height: 20px"></div>
      <el-form :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="设备编号" label-width="90px" prop="device_id">
          <el-autocomplete
            style="width: 100%"
            class="inline-input"
            v-model="addEditForm.device_id"
            :fetch-suggestions="querySearch"
            placeholder="请输入设备编号"
            :trigger-on-focus="false"
            @select="handleSelect"
          ></el-autocomplete>
        </el-form-item>
<!--        <el-form-item label="设备号码" label-width="90px" prop="phone">-->
<!--          <el-input style="width: 100%" placeholder="请输入设备号码" v-model="addEditForm.phone" :disabled="isEdit" autocomplete="off"></el-input>-->
<!--        </el-form-item>-->
      </el-form>
      <div>
        <el-table
          :data="showTable"
          border
          style="width: 100%;margin-top: 10px"
          highlight-current-row
          size="mini">
          <el-table-column
            prop="oldNew"
            label=""
            min-width="60"
            align="center">
          </el-table-column>
          <el-table-column
            prop="deviceid"
            label="IMEI"
            min-width="150"
            align="center">
          </el-table-column>
          <el-table-column
            label="设备号码"
            min-width="130"
            align="center">
            <template slot-scope="scope">
              <span v-if="scope.$index === 0">{{scope.row.phone}}</span>
              <el-input v-else v-model="newDevice.simcardno" size="mini" style="width: 100%" placeholder="请输入设备号码" autocomplete="off"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="last_online"
            label="最后在线时间"
            min-width="140"
            align="center">
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 20px">
        <div class="send-btn" @click="openNext('addEditForm')">
          <span>下一步</span>
        </div>
      </div>
      <div style="height: 20px;clear: both"></div>
    </div>
    <div v-if="active === 2">
      <div style="margin-top: 40px;text-align: center;font-size: 20px">
        <span>新设备IMEI号为：{{newDevice.deviceid}}，<br>新设备号码为：{{newDevice.simcardno}}，<br>是否确定更换此设备？</span>
      </div>
      <div style="margin-top: 15px">
        <el-row>
          <el-col :span="12">
            <div class="cancel-btn" @click="isNoChange()">
              <span>取消</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="send-btn" @click="isYesChange()">
              <span>确定更换</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="height: 30px;"></div>
    </div>
    <el-dialog
      :visible.sync="openTableShow"
      v-if="openTableShow"
      width="650px"
      :show-close="true"
      :close-on-click-modal="false"
      center
      append-to-body
      class="all-open">
      <div class="title-top-alarm">
        <div>
          <span>设备信息</span>
        </div>
        <div class="line-title"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {searchunbinddevice, changedevicebyimei} from '../../../api/device'

export default {
  name: 'changeDevice',
  model: {
    prop: 'changeDeviceShow',
    event: 'change'
  },
  props: {
    changeObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      showTitle0: '进行中',
      showTitle1: '待处理',
      showTitle2: '待处理',
      weatherInfo: '请确认新设备开机且通讯正常',
      selectDevice: '绑定新设备',
      endMsg: '确认新设备',
      active: 0,
      addEditForm: {
        deviceid: '',
        phone: ''
      },
      addEditRules: {
        device_id: [
          { required: true, message: '请输入设备编号', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请输入设备号码', trigger: 'blur' }
        ]
      },
      openTableShow: false,
      showTable: [
        // {oldNew: '旧设备', deviceid: '423523623435', last_online: '2021-09-14 12:00:00'},
        // {oldNew: '新设备', deviceid: '423523623435', last_online: '2021-09-14 12:00:00'}
      ],
      oldDevice: {},
      newDevice: {
        simcardno: ''
      }
    }
  },
  created () {
    this.getStartData()
  },
  methods: {
    getStartData () {
      this.oldDevice.oldNew = '旧设备'
      this.oldDevice.deviceid = this.changeObj.deviceRow.deviceid
      this.oldDevice.last_online = this.changeObj.deviceRow.last_online
      this.oldDevice.phone = this.getDevicePhone(this.changeObj.deviceRow)
      this.showTable.push(this.oldDevice)
      // console.log(this.changeObj.deviceRow)
    },
    getDevicePhone (row) {
      if (row.simcardno !== '' && row.simcardno !== '<nil>') {
        return row.simcardno
      } else {
        if (row.pid > 0) {
          return row.p_phone
        } else {
          return row.h_phone
        }
      }
    },
    isNo () {
      this.$message({
        message: '请开机并等待联网通讯正常。',
        type: 'warning'
      })
      this.$emit('change', false)
    },
    isYes () {
      this.active = 1
      this.weatherInfo = '已确认新设备开机且通讯正常'
      this.showTitle0 = '已完成'
      this.showTitle1 = '进行中'
    },
    querySearch (queryString, cb) {
      // console.log(this.changeObj.deviceRow.devicetype)
      if (queryString.length < 4) {
        return
      }
      searchunbinddevice({lessdeviceid: queryString}).then(res => {
        let re = []
        for (let i = 0; i < res.data.devices.length; i++) {
          if (this.changeObj.deviceRow.devicetype === res.data.devices[i].devicetype) {
            re.push({
              value: res.data.devices[i].deviceid + '(' + this.getDtpye(res.data.devices[i].devicetype) + ')',
              deviceid: res.data.devices[i].deviceid,
              dtype: res.data.devices[i].devicetype,
              id: res.data.devices[i].id,
              simcardno: res.data.devices[i].simcardno,
              obj: res.data.devices[i]
            })
          }
        }
        cb(re)
        // console.log('re', re)
      })
    },
    getDtpye (type) {
      return this.commonType.getDeviceType(type)
    },
    handleSelect (item) {
      // console.log(item)
      this.newDevice = item.obj
      let obj = {
        oldNew: '新设备',
        deviceid: item.obj.deviceid,
        last_online: item.obj.last_online
      }
      this.showTable.push(obj)
    },
    openNext (formName) {
      if (this.newDevice.simcardno === '') {
        this.$message.error('请输入新设备号码')
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.active = 2
          this.weatherInfo = '已选择更新时间和天气'
          this.showTitle0 = '已完成'
          this.showTitle1 = '已完成'
          this.showTitle2 = '进行中'
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    isNoChange () {
      this.$emit('change', false)
    },
    isYesChange () {
      let data = {
        hid: this.changeObj.deviceRow.hid,
        pid: this.changeObj.deviceRow.pid,
        oldimei: this.changeObj.deviceRow.deviceid,
        olddid: this.changeObj.deviceRow.id,
        oldphone: this.oldDevice.phone,
        dtype: this.changeObj.deviceRow.devicetype,
        newimei: this.newDevice.deviceid,
        newdid: this.newDevice.id,
        newphone: this.newDevice.simcardno
      }
      changedevicebyimei(data).then(res => {
        this.$notify({
          title: '成功',
          message: '成功更换设备',
          type: 'success',
          duration: 2000
        })
        this.$emit('getFatherEditDevice')
        this.$emit('change', false)
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/deviceComponents/changeDevice.vue